import React from 'react';
import { TbBuildingStore, TbPlus } from 'react-icons/tb';
import { Link, useLocation } from 'react-router-dom';

import { Typography } from '@/components/atoms/Typography';
import { LoadingProcess } from '@/components/molecules/LoadingProcess';
import { PageTitle } from '@/components/molecules/PageTitle';

export const RestaurantInactivePage = () => {
  const location = useLocation();

  const getRestaurantName = () => {
    const searchParams = new URLSearchParams(location.search);

    const restaurantSlug = searchParams.keys().next().value;

    if (restaurantSlug) {
      return restaurantSlug
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }

    return 'Votre restaurant';
  };

  const restaurantName = getRestaurantName();

  return (
    <div className="h-full w-full max-w-5xl mx-auto">
      <PageTitle firstTitle="Processus de" secondTitle="vérification" />
      <div className="py-10 my-20 border rounded-xl px-10">
        <LoadingProcess restaurantName={restaurantName} />

        <div className="flex mt-20 justify-center gap-4">
          <Link to="/proposal-restaurant">
            <button className="border flex items-center gap-2 mx-auto px-10 py-2 rounded-full bg-primary">
              <TbPlus className="text-xl text-white" />
              <Typography weight="medium" color="white" align="center">
                Ajouter un nouveau restaurant
              </Typography>
            </button>
          </Link>
          <Link to="/?tab=pending">
            <button className="border flex items-center gap-2 mx-auto px-10 py-2 rounded-full bg-primary">
              <TbBuildingStore className="text-xl text-white" />
              <Typography weight="medium" color="white" align="center">
                Retour à l'accueil
              </Typography>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};
